/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq5a_Step11Inputs */

const zh_pricing_faq5a_step11 = /** @type {(inputs: Pricing_Faq5a_Step11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. 前往`)
};

const en_pricing_faq5a_step11 = /** @type {(inputs: Pricing_Faq5a_Step11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Navigate to`)
};

const es_pricing_faq5a_step11 = /** @type {(inputs: Pricing_Faq5a_Step11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Ve a la`)
};

/**
* | output |
* | --- |
* | "1. Navigate to" |
*
* @param {Pricing_Faq5a_Step11Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq5a_step11 = /** @type {((inputs?: Pricing_Faq5a_Step11Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq5a_Step11Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq5a_step11(inputs)
	if (locale === "en") return en_pricing_faq5a_step11(inputs)
	return es_pricing_faq5a_step11(inputs)
});
export { pricing_faq5a_step11 as "pricing_faq5A_step1" }